export const apiBase = process.env.REACT_APP_API_BASE || '';

export const buildApiUrl = (path) => (apiBase ? `${apiBase}${path}` : path);
